import { makeStyles } from "tss-react/mui"
import { useAppSelector } from "../../../../store/storeHooks"
import { selectAuthenticatedUser } from "../../../../login/loginSelectors"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { getAdminDetails, GetAdminDetailsResponse, UserQuery } from "../../../../users/userApi"
import { Card, Grid } from "@mui/material"
import { ProfileCard } from "../../../../profile/components/ProfileCard"
import { UserLanguageCard } from "../../../../nonAdminUser/components/UserLanguageCard"
import { UserPasswordCard } from "../../../../nonAdminUser/components/UserPasswordCard"
import { MatchEnvironment } from "../../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../../environment/envTypes"

const useStyles = makeStyles()((theme) => ({
    wrap: {
        display: "grid",
        gap: "2rem",
    },
    box: {
        border: `1px solid ${theme.palette.tailwind.slate[100]}`,
        borderRadius: ".75rem",
        boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.08)",
        display: "flex",
        flexDirection: "column",
        background: "white",
        padding: "2rem",
        width: "100%",
    },
}))

const transformAdminData = (data: GetAdminDetailsResponse) => data.admin

export const ServiceCenterProfileContent = () => {
    const { classes } = useStyles()
    const user = useAppSelector(selectAuthenticatedUser)

    if (!user) {
        return null
    }

    const { data: existingAdmin } = useApiQuery(getAdminDetails, {
        queryName: UserQuery.ADMIN_DETAILS,
        dependencies: {
            userId: user.id,
        },
        select: transformAdminData,
    })

    if (!existingAdmin?.user) {
        return null
    }

    return (
        <Grid container spacing="1.5rem" alignItems="flex-start" columns={{ xs: 8, md: 12 }}>
            <Grid item xs={8} md={7} className={classes.wrap}>
                <Card className={classes.box}>
                    <ProfileCard user={existingAdmin.user} />
                </Card>
            </Grid>

            <Grid item xs={8} md={5} className={classes.wrap}>
                <Card className={classes.box}>
                    <UserLanguageCard />
                </Card>
                <MatchEnvironment environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]}>
                    <Card className={classes.box}>
                        <UserPasswordCard />
                    </Card>
                </MatchEnvironment>
            </Grid>
        </Grid>
    )
}
